import { Button, ButtonProps, Tooltip } from '@mui/material'
import { useFormikContext } from 'formik'
import React from 'react'

type Props = Omit<ButtonProps, 'children' | 'onClick' | 'onDoubleClick'> & {
  // Resolving to false means the autofill failed and the double click must not submit.
  onAutofill: () => void | boolean | Promise<void | boolean>
}

export default function AutofillButton({ onAutofill, ...props }: Props) {
  const { submitForm } = useFormikContext()

  const autofillAndSubmit = async () => {
    if ((await onAutofill()) === false) return
    await submitForm()
  }

  return (
    <Tooltip title="Double click to autofill and submit">
      {/* A disabled button fires no events, so the tooltip listens on the wrapper. */}
      <span>
        <Button onClick={() => onAutofill()} onDoubleClick={autofillAndSubmit} variant="outlined" {...props}>
          Autofill
        </Button>
      </span>
    </Tooltip>
  )
}
